import { Button } from "@similarweb/ui-components";
import { Box, Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import GradientButton from "app/pages/sales-intelligence/modules/ai-agent/components/GradientButton/GradientButton";
import GradientTextfield from "app/pages/sales-intelligence/modules/ai-agent/components/GradientTextfield/GradientTextfield";

type AIAgentEmailRefinePanelFooterProps = {
    isLoading: boolean;
    isBlocked: boolean;
    isCompetitorsShown: boolean;
    onCancelCompetitors: VoidFunction;
    onApplyCompetitors: VoidFunction;
    localText: string;
    isApplyCompetitorsDisabled: boolean;
    onTextChange: (value?: string) => void;
    onSubmitChat: VoidFunction;
    onSubmitPanel: VoidFunction;
};

export const AIAgentEmailRefinePanelFooter = ({
    isLoading,
    isBlocked,
    isCompetitorsShown,
    onCancelCompetitors,
    onApplyCompetitors,
    localText,
    isApplyCompetitorsDisabled,
    onTextChange,
    onSubmitChat,
    onSubmitPanel,
}: AIAgentEmailRefinePanelFooterProps) => {
    return (
        <Box
            width="calc(100% - 12px)"
            position="sticky"
            bottom="0"
            data-automation="refine-panel-footer"
        >
            {isCompetitorsShown ? (
                <Flex
                    gap="8px"
                    justifyContent="flex-end"
                >
                    <Button
                        type="flat"
                        onClick={onCancelCompetitors}
                        dataAutomation="cancel-button"
                    >
                        {translate("si.common.button.cancel")}
                    </Button>
                    <Button
                        onClick={onApplyCompetitors}
                        isDisabled={isApplyCompetitorsDisabled}
                        dataAutomation="apply-button"
                    >
                        {translate("si.common.button.apply")}
                    </Button>
                </Flex>
            ) : (
                <GradientTextfield
                    value={localText}
                    placeholder={translate("si.pages.ai_agent_email.panel.input.placeholder")}
                    autoFocus
                    isDisabled={isBlocked}
                    onChange={onTextChange}
                    onKeyDown={(e: React.KeyboardEvent<HTMLTextAreaElement>) => {
                        if (e.key === "Enter" && !e.shiftKey) {
                            e.preventDefault();
                            onSubmitChat();
                        }
                    }}
                    actionButton={
                        <GradientButton
                            variant={isBlocked ? "disabled" : isLoading ? "flatRectangle" : "flat"}
                            onClick={onSubmitPanel}
                            disabled={isBlocked}
                        />
                    }
                />
            )}
        </Box>
    );
};
